import { useEffect, useRef, useState } from 'react';
import { useWallet } from '../context/WalletContext';
import { useContracts } from '../context/ContractContext';

export default function useAdminRole() {
  const { account, wrongNetwork } = useWallet();
  const { main } = useContracts();
  const [state, setState] = useState({ loading: true, isOwner: false, isAdmin: false, isHelper: false });
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    if (!account || wrongNetwork) {
      setState({ loading: false, isOwner: false, isAdmin: false, isHelper: false });
      return () => { mountedRef.current = false; };
    }
    (async () => {
      try {
        const [own, adm, help] = await Promise.all([
          main.owner().catch(() => null),
          main.admin().catch(() => null),
          main.helper().catch(() => null)
        ]);
        if (!mountedRef.current) return;
        const acc = account.toLowerCase();
        setState({
          loading: false,
          isOwner:  !!own  && own.toLowerCase()  === acc,
          isAdmin:  !!adm  && adm.toLowerCase()  === acc,
          isHelper: !!help && help.toLowerCase() === acc
        });
      } catch (_) {
        if (!mountedRef.current) return;
        setState({ loading: false, isOwner: false, isAdmin: false, isHelper: false });
      }
    })();
    return () => { mountedRef.current = false; };
  }, [account, main, wrongNetwork]);

  const allowed = state.isOwner || state.isAdmin || state.isHelper;
  return { ...state, allowed };
}
